<md-dialog>
	<div md-dialog-header>
		<md-icon md-border [icon]="{ type: 'url', icon: 'untitled-ui/time/clock-refresh' }"></md-icon>
		<div class="md-text-lg-semibold">Oops! Too Late to Reschedule</div>
	</div>

	<div class="reschedule-warning">
		<md-icon class="icon" [icon]="{ type: 'url', icon: 'untitled-ui/alerts/alert-circle' }"></md-icon>
		<div class="content">
			<span>
				Lessons can only be rescheduled more than 24 hours in advance. Since we're already within that timeframe, this lesson will be marked as an
				absence.
			</span>
			<span>Don’t worry, you’ll automatically get an email with details about the fee and instructions on how to book a makeup lesson.</span>
			<span>Please take a moment to send your instructor a quick message on Microsoft Teams to inform them that you won't be able to attend</span>
			<a href="https://help.languagebird.com/what-is-languagebirds-lateabsent-policy" target="_blank">
				Late Reschedule/Tardy/Absence Policy <md-icon [icon]="{ type: 'url', icon: 'untitled-ui/arrows/arrow-narrow-right' }"></md-icon>
			</a>
		</div>
	</div>
</md-dialog>
